import { useState } from "react";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { auth, timestamp } from "@/api/firebase/firebase.config";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { RegisterFormProps } from "../components/RegisterForm/RegisterForm.types";

export const useRegister = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const navigate = useNavigate();

  const handleRegister = async (values: RegisterFormProps) => {
    if (values.password !== values.passwordConfirm) {
      setError(new Error("Passwords do not match"));
      return;
    }

    if (values.terms === false) {
      setError(new Error("You must accept the terms and conditions"));
      return;
    }

    createUserWithEmailAndPassword(auth, values.email, values.password)
      .then((userCredential) => {
        const uid = userCredential.user.uid;

        collectionRef.Profiles.doc(uid).set({
          uid: uid,
          email: values.email,
          createdAt: timestamp.now(),
          onboarded: false,
          firstName: null,
          lastName: null,
          dateOfBirth: null,
          gender: null,
          nationality: null,
          countryOfResidence: null,
          phoneNumber: null,
        });

        navigate(`/`);

        if (auth.currentUser) {
          sendEmailVerification(auth.currentUser)
            .then(() => {
              console.log("Email verification sent");
            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
              console.log("Error occurred: ", errorCode, errorMessage);
              setError(error);
            });
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log("Error ocured: ", errorCode, errorMessage);
        setError(error);
      });

    if (!error) {
      return true;
    } else {
      return false;
    }
  };

  return {
    loading,
    setLoading,
    error,
    setError,
    handleRegister,
  };
};
